<template>
  <router-view :key="$route.fullPath"/>
</template>

<style>
#app {
  font: 12px/1 "Microsoft YaHei","微软雅黑","arial","tahoma","MicrosoftJhengHei";
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  /*margin-top: 60px;*/
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.container-z {
  /*max-width: 1000px;*/
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
}
.second-container {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: flex-start;
  width: 100%;
  height: 98vh;
  padding: 0;
  margin: 0;
}
</style>
